<template>
  <div v-if="showCta" class="text-center">
    <a
      class="btn btn-amber shadow-0"
      :href="addAffiliateMobileAppParams(primary.link ?? undefined)"
      :target="primary.targetBlank ? '_blank' : undefined"
      >{{ primary.label }}</a
    >
    <div v-if="secondary" class="mt-3">
      <span class="mr-1.5">{{ $t('or') }}</span>
      <a
        class="underline font-semibold text-gray-500 hover:text-gray-700"
        :href="addAffiliateMobileAppParams(secondary?.link ?? undefined)"
        :target="secondary.targetBlank ? '_blank' : undefined"
      >
        {{ secondary.label }}
      </a>
    </div>
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  primary: { label: string | null; link: string | null; targetBlank?: boolean | null }
  secondary?: { label: string | null; link: string | null; targetBlank?: boolean | null } | null
}>()

const showCta = computed(() => {
  return (
    Boolean(props.primary.label) &&
    !hasInvalidPlaceholderValue(props.primary.label) &&
    !hasInvalidPlaceholderValue(props.secondary?.label)
  )
})
</script>
